import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ReasonWhySection } from '../components/ReasonWhySection';
import { BenefitsSection } from '../components/BenefitsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductInUseSection } from '../components/ProductInUseSection';
import { ProblemAwarenessSection } from '../components/ProblemAwarenessSection';
import { MaterialsSection } from '../components/MaterialsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { JourneyTimelineSection } from '../components/JourneyTimelineSection';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-421">
      <HeroSection data-id="element-422" />
      <ReasonWhySection data-id="element-423" />
      <BenefitsSection data-id="element-424" />
      <MechanismSection data-id="element-425" />
      <ProductInUseSection data-id="element-426" />
      <ProblemAwarenessSection data-id="element-427" />
      <MaterialsSection data-id="element-428" />
      <TestimonialsSection data-id="element-429" />
      <JourneyTimelineSection data-id="element-430" />
      <DifferentiationSection data-id="element-431" />
      <BonusSection data-id="element-432" />
      <PricingSection data-id="element-433" />
      <FAQSection data-id="element-434" />
      <GuaranteeSection data-id="element-435" />
      <Footer data-id="element-436" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden z-50" data-id="element-437">
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full bg-[#1E40AF] text-white font-bold py-3 px-6 rounded-full shadow-lg" data-id="element-438">
          Get SnoreStop™ Now
        </button>
      </div>
    </div>;
}